import BurgerMenuHeader from './BurgerMenuHeader';
import DesktopHeader from './Desktop';
import { HeaderBarProvider } from './contexts/header-bar';
import LanguageSelector from '@/components/app/LanguageSelector';
import { classes } from '@/helpers/styling';
import useAppFilter from '@/hooks/layout/useAppFilter';
import useCheckLocalStorage from '@/hooks/browser/useCheckLocalStorage';
import useCurrentLayout from '@/hooks/layout/useCurrentLayout';
import useShouldRenderForMobile from '@/hooks/layout/useShouldRenderForMobile';
import useLanguage from '@/hooks/language/useLanguage';

// Responsive header bar with - displays the desktop header on desktop screens
// and the burger menu on mobile screens
// This header bar is displayed at all times
const HeaderBarResponsive = () => {
  const { localStorageAvailable, localStorageChecked } = useCheckLocalStorage();
  const { appIsFiltered } = useAppFilter();
  const { browserSize } = useCurrentLayout();
  const shouldRenderForMobile = useShouldRenderForMobile();
  const { handleOpenLanguageSelector } = useLanguage();

  // Do not display the responsive header bar if local storage is not available
  // As then we would display a screen requesting the user to enable cookies
  if (
    !browserSize
      || (localStorageChecked && !localStorageAvailable)
  ) {
    return null;
  }

  // Return the burger menu header if mobile
  // Else return the desktop header
  return (
    <HeaderBarProvider onClickChooseLanguage={ handleOpenLanguageSelector }>
      <LanguageSelector />
      {
        shouldRenderForMobile ? (
          <BurgerMenuHeader />
        ) : (
          <div
            className={ classes(
              'desktop-menu-wrapper-perm',
              { '--is-filtered': appIsFiltered }
            ) }
          >
            <DesktopHeader />
          </div>
        )
      }
    </HeaderBarProvider>
  );
};

export default HeaderBarResponsive;